import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    api.get("/admin/audit?limit=200").then((r) => setLogs(r.data));
  }, []);
  return (
    <div>
      <h1 className="font-display text-3xl lg:text-4xl mb-2">{`Journal d'actions`}</h1>
      <p className="text-xs uppercase tracking-widest text-[#6B6B6B] mb-8">{`Historique des actions administrateur`}</p>

      <div className="border border-black/5 bg-white" data-testid="audit-table">
        <table className="w-full text-sm">
          <thead className="border-b border-black/5 text-[10px] uppercase tracking-widest text-[#6B6B6B]">
            <tr>
              <th className="px-4 py-3 text-left">Date</th>
              <th className="px-4 py-3 text-left">Admin</th>
              <th className="px-4 py-3 text-left">Action</th>
              <th className="px-4 py-3 text-left">Détails</th>
            </tr>
          </thead>
          <tbody>
            {logs.length === 0 && (
              <tr><td colSpan="4" className="text-center py-12 text-[#6B6B6B]">Aucune action enregistrée.</td></tr>
            )}
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-black/5">
                <td className="px-4 py-3 text-xs text-[#6B6B6B]">{new Date(l.timestamp).toLocaleString("fr-FR")}</td>
                <td className="px-4 py-3 text-xs">{l.admin_email}</td>
                <td className="px-4 py-3 text-[#B8860B] uppercase tracking-widest text-xs">{l.action}</td>
                <td className="px-4 py-3 text-xs text-[#6B6B6B] font-mono truncate max-w-md">{JSON.stringify(l.details)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
